import React, { useEffect, useState } from "react";
import "./Orderhistory.css";
import { BsBoxFill, BsCartCheckFill, BsCheckCircle, BsArrowRepeat } from "react-icons/bs";
import { FaTruckArrowRight, FaPeopleCarryBox } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";
import Review from "./Review";
import Orderimg from "../../assests/3.png";
import Address from "./Address";

function OrderTracking({ profile, profileupdate }) {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [ordershistory, setOrdersHistory] = useState([]);

  const order = async () => {
    const formData = new FormData();
    formData.append("id", userData?.id);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/order_history.php`,
        formData
      );

      const data = res.data?.data || res.data;

      if (res.data) {
        setOrdersHistory(data);
      } else {
        console.warn("Remove failed:", res.data.message || "Unknown error");
      }
    } catch (err) {
      console.error("Error removing item:", err);
    }
  };

  useEffect(() => {
    order();
  }, []);

  const handleSearch = async () => {
    if (!searchQuery.trim()) return;

    try {
      const response = await fetch(
        `https://api.example.com/orders?query=${searchQuery}`
      );
      const data = await response.json();
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const statusOrder = {
    Ordered: 0,
    Packed: 1,
    Shipped: 2,
    Delivered: 3,
  };

  const statusMapping = {
    "In Progress": "Ordered",
    Cancelled: "Cancelled",
    Ordered: "Ordered",
    Packed: "Packed",
    Shipped: "Shipped",
    Delivered: "Delivered",
  };

  // const normalizedStatus = statusMapping[ordershistory.map(order,index)=>(order?.status)] || "Ordered";
  const normalizedStatus = Array.isArray(ordershistory)
    ? ordershistory.map((order) => ({
      ...order,
      normalizedStatus: statusMapping[order.status] || "Ordered",
    }))
    : [];

  const isCancelled = normalizedStatus.every(
    (order) => order.normalizedStatus === "Cancelled"
  );

  const handleOrderClick = (orderId) => {
    setExpandedOrderId((prevId) => (prevId === orderId ? null : orderId));
    setActiveReviewId(null);
    setActiveCancelId(null);
  };

  const handleDownloadInvoice = async (order_id) => {
    if (!order_id) {
      console.warn("No order ID provided.");
      return;
    }

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/apis/invoice.php`,
        {
          params: { order_id },
          responseType: "blob",
        }
      );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice_${order_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Invoice downloaded successfully");
    } catch (err) {
      console.error("Error downloading invoice:", err);
      toast.error("Something went wrong while fetching invoice.");
    }
  };

  const [activeReviewId, setActiveReviewId] = useState(null);
  const [activeCancelId, setActiveCancelId] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const handleReview = (productId, orderId) => {
    setExpandedOrderId(null);
    setActiveReviewId((prev) =>
      prev?.productId === productId && prev?.orderId === orderId
        ? null
        : { productId, orderId }
    );
  };

  const handlecancel = (id) => {
    setExpandedOrderId(null);
    setActiveCancelId((prev) => (prev === id ? null : id));
  };

  const handlereviewBack = (orderId) => {
    setActiveReviewId(null);
    setExpandedOrderId((prevId) => (prevId === orderId ? null : orderId));
  };

  const handlecancelBack = (orderId) => {
    setActiveCancelId(null);
    setExpandedOrderId((prevId) => (prevId === orderId ? null : orderId));
  };

  const handlechangeadd = async (orderId) => {
    const formData = new FormData();
    formData.append("ship_add", selectedAddress);
    formData.append("id", orderId);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/order_add_update.php`,
        formData
      );
      const rawData = res.data?.data;
      const data = Array.isArray(rawData) ? rawData : [];
      if (res.data?.success === true) {
        setShowAddressModal(false);
        order();
        toast.success("Address changed successfully");
      } else {
        console.error("error on fetching");
      }
    } catch (err) {
      console.error("Error fetching bag", err);
    }
  };

  return (
    <div className="oh-order-tracking-container">
      {ordershistory.length > 0 ? (
        <>
          <div className="oh-head">My Orders</div>

          <div className="oh-search-container">
            <FaSearch className="oh-search-icon" />
            <input
              type="text"
              placeholder="Search orders..."
              className="oh-search-bar"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            />
          </div>

          <div className="oh-order-list-full">
            {ordershistory.map((order) => {
              const normalizedStatus =
                order.status?.charAt(0).toUpperCase() +
                order.status?.slice(1).toLowerCase();
              const currentStatusLevel = statusOrder[normalizedStatus] || 0;

              return (
                <div
                  style={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "white",
                  }}
                >
                  <div
                    key={order.id}
                    className="oh-order-box"
                    onClick={() => handleOrderClick(order.order_id)}
                  >
                    <div className="oh-left-section">
                      <div>
                        <span className="product-title">
                          {order.tracking_number}
                        </span>

                        {order.status === "Cancelled" ? (
                          <>
                            <p className="oh-cancelled-text">
                              {order.expected_date}
                            </p>
                            <span className="oh-status-badge oh-badge-cancelled">
                              Cancelled
                            </span>
                          </>
                        ) : order.status === "Delivered" ? (
                          <>
                            <p className="oh-delivered-text">
                              {order.expected_date}
                            </p>
                            <span className="oh-status-badge oh-badge-delivered">
                              Delivered
                            </span>
                          </>
                        ) : order.status === "Shipped" ? (
                          <>
                            <p className="oh-delivery-text">
                              {order.expected_date}
                            </p>
                            <span className="oh-status-badge oh-badge-shipped">
                              Shipped
                            </span>
                          </>
                        ) : (
                          <>
                            <p className="oh-delivery-text">
                              {order.expected_date}
                            </p>
                            <span className="oh-status-badge oh-badge-inprogress">
                              In Progress
                            </span>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="oh-right-section">
                      <p className="oh-order-price">
                        {new Intl.NumberFormat("en-IN", {
                          style: "currency",
                          currency: "INR",
                        }).format(order.total_price)}
                      </p>
                    </div>
                  </div>
                  {expandedOrderId === order.order_id && (
                    <div className="oh-expanded-details">
                      <p>
                        <strong>Order ID:</strong> {order.tracking_number}
                      </p>
                      {/* {order.status === "Delivered" ? (
                        <p>
                          <div className="reviewbtn-container">
                            <button
                              className="reviewbtn"
                              onClick={() => handleReview(order?.order_id)}
                            >
                              Add Review
                            </button>
                          </div>
                        </p>
                      ) : order.status === "In Progress" ? (
                        <p>
                          <div className="reviewbtn-container">
                            <button
                              className="reviewbtn"
                              onClick={() => handlecancel(order?.order_id)}
                            >
                              Cancel Order
                            </button>
                          </div>
                        </p>
                      ) : null} */}

                      {order.status === "In Progress" ? (
                        <div className="reviewbtn-container">
                          <button
                            className="reviewbtn"
                            onClick={() => {
                              setSelectedOrderId(order?.order_id);
                              setShowAddressModal(true);
                            }}
                          >
                            Change Address
                          </button>

                          <button
                            className="reviewbtn cancel"
                            onClick={() => handlecancel(order?.order_id)}
                          >
                            Cancel Order
                          </button>
                        </div>
                      ) : null}

                      {showAddressModal && (
                        <div className="modal-overlay">
                          <div className="modal">
                            <h2>Change Address</h2>

                            <Address
                              profileupdate={profileupdate}
                              profile={profile}
                              onSelectAddress={(address) =>
                                setSelectedAddress(address)
                              }
                            />
                            {/* 
                            <textarea
                              placeholder="Enter new address..."
                              rows="4"
                              className="address-input"
                            ></textarea> */}
                            <div className="modal-actions">
                              <button
                                className="modal-btn save"
                                onClick={() => handlechangeadd(selectedOrderId)}
                              >
                                Save
                              </button>
                              <button
                                className="modal-btn cancel"
                                onClick={() => setShowAddressModal(false)}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="order-card">
                        <div className="oh-middle-section">
                          <div
                            className={`oh-progress-container ${isCancelled ? "blurred" : ""
                              }`}
                          >
                            {["Ordered", "Verified", "Ongoing", "Shipped", "Delivered"].map(
                              (step, index) => (
                                <React.Fragment key={step}>
                                  <div
                                    className={`step ${currentStatusLevel >= statusOrder[step]
                                      ? "active"
                                      : ""
                                      }`}
                                    title={step}
                                  >
                                    {step === "Ordered" && (
                                      <BsCartCheckFill className="oh-step-icon" />
                                    )}
                                    {step === "Verified" && (
                                      <BsCheckCircle className="oh-step-icon" />
                                    )}
                                    {step === "Ongoing" && (
                                      <BsArrowRepeat className="oh-step-icon" />
                                    )}
                                    {step === "Shipped" && (
                                      <FaTruckArrowRight className="oh-step-icon" />
                                    )}
                                    {step === "Delivered" && (
                                      <FaPeopleCarryBox className="oh-step-icon" />
                                    )}
                                    <span>{step}</span>
                                  </div>
                                  {index < 4 && <div className="oh-line" />}
                                </React.Fragment>
                              )
                            )}
                          </div>
                        </div>
                        <div className="delivery-section">
                          <h3>Delivery Details</h3>
                          <p>📍 {order.ship_add}</p>
                          <p>📞 {order.contact}</p>
                        </div>
                        <div className="price-section">
                          <h3>Product Details</h3>
                          <table>
                            <th>Product Name</th>
                            <th>Size</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Total</th>
                            <th></th>
                            <tbody>
                              {order.products.map((prod, idx) => (
                                <tr key={idx}>
                                  <td>
                                    <div className="oh-left-section ">
                                      <img
                                        src={`${process.env.REACT_APP_BASEURL
                                          }/apis/vendor/uploads/products/${prod?.prod_img.split(",")[0]
                                          }`}
                                        alt={order.prod_name}
                                        className="oh-images"
                                      />
                                      {prod.prod_name}
                                    </div>
                                  </td>
                                  <td>{prod.size}</td>
                                  <td>₹{prod.price}</td>
                                  <td>{prod.quantity}</td>
                                  <td>
                                    {new Intl.NumberFormat("en-IN", {
                                      style: "currency",
                                      currency: "INR",
                                      minimumFractionDigits: 2,
                                    }).format(
                                      (parseFloat(
                                        (prod?.price).replace(/,/g, "")
                                      ) || 0) * (parseInt(prod.quantity) || 0)
                                    )}
                                  </td>
                                  <td>
                                    {order.status === "Delivered" ? (
                                      <button
                                        className="reviewbtn"
                                        onClick={() =>
                                          handleReview(
                                            prod?.product_id,
                                            order?.order_id
                                          )
                                        }
                                      >
                                        Add Review
                                      </button>
                                    ) : null}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <p className="cod">
                            Cash On Delivery: ₹{order.total_price}
                          </p>
                        </div>

                        {order.status === "Delivered" ? (
                          <button
                            className="downloadbtn"
                            onClick={() => {
                              handleDownloadInvoice(order?.order_id);
                            }}
                          >
                            Download Invoice
                          </button>
                        ) : null}
                      </div>
                    </div>
                  )}

                  {activeReviewId?.orderId === order.order_id &&
                    order.products.some(
                      (prod) => prod.product_id === activeReviewId.productId
                    ) && (
                      <tr>
                        <td colSpan={6}>
                          <button
                            className="backbtn"
                            onClick={() => handlereviewBack(order.order_id)}
                          >
                            ← Back
                          </button>
                          <Review
                            prodid={activeReviewId.productId}
                            orderid={order.order_id}
                            type="review"
                          />
                        </td>
                      </tr>
                    )}

                  {activeCancelId === order?.order_id && (
                    <>
                      <button
                        className="backbtn"
                        onClick={() => handlecancelBack(order.id)}
                      >
                        ← Back
                      </button>
                      <Review prodid={activeCancelId} type={"cancel"} />
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className="mt-cart-container">
          <img
            src={Orderimg}
            alt="Empty Wishlist"
            className="empty-cart-image"
          />
        </div>
      )}
    </div>
  );
}

export default OrderTracking;
